import React from 'react';
import {
  BANKER_CARDS_BOX,
  CARDS_BOX,
  CARDS_TYPE,
  HORIZONTAL_CARDS_INDEX,
} from '../../enums/cardTypes';
import { IDS } from '../../enums/constants';
import { BET_TYPES } from '../../enums/betTypesEnum';

function BetTypeInfo({ cards, totalPoint, imgSrc, betType, selectedCardType }) {
  return (
    <>
      <img src={imgSrc} alt='' className='chine-bg' />
      <div className='card-wrapper'>
        {BET_TYPES.PLAYER === betType ? (
          CARDS_BOX.map((item, index) => {
            const card = cards.length > index ? cards[index] : null;
            return (
              <div
                key={IDS[index]}
                className={`card-holder ${card ? CARDS_TYPE[card.card] : 'empty'} ${
                  index === HORIZONTAL_CARDS_INDEX ? 'horizontal' : ''
                } ${selectedCardType}`}
              >
                <div className='card-holder-inner' />
              </div>
            );
          })
        ) : (
          <>
            {BANKER_CARDS_BOX.map((item, index) => {
              const card = cards.length > 1 - index ? cards[1 - index] : null;
              return (
                <div
                  key={IDS[index]}
                  className={`card-holder ${
                    card ? CARDS_TYPE[card.card] : 'empty'
                  } ${selectedCardType}`}
                >
                  <div className='card-holder-inner' />
                </div>
              );
            })}
            <div
              className={`card-holder horizontal ${
                cards.length > HORIZONTAL_CARDS_INDEX && cards[HORIZONTAL_CARDS_INDEX]
                  ? CARDS_TYPE[cards[HORIZONTAL_CARDS_INDEX].card]
                  : 'empty'
              } ${selectedCardType}`}
            >
              <div className='card-holder-inner' />
            </div>
          </>
        )}
        {totalPoint !== null && cards.length ? (
          <span className='bottom-card-number'>{totalPoint}</span>
        ) : null}
      </div>
    </>
  );
}

export default BetTypeInfo;
